import { useAdSupplierGroup } from '@/hooks/useAdSupplierGroups'
import { useViewMode } from '@/stores/viewMode'
import { PageHeader } from '@/components/PageHeader'
import AdSupplierGroupInfo from './AdSupplierGroupInfo'

export default function AdSupplierGroupPage() {
  const { id: groupId } = useViewMode()
  const { adSupplierGroup, isLoading } = useAdSupplierGroup(groupId)

  return (
    <div className="space-y-6">
      <PageHeader title="集團資訊" description="管理廣告商集團資訊" level="section" />
      <AdSupplierGroupInfo adSupplierGroup={adSupplierGroup} isLoading={isLoading} />
    </div>
  )
}
